// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"340a8a7c","102":"f03243ca","156":"9fd7973c","184":"52ddccbf","510":"2b7ec215","533":"be55b01f","572":"fd374c7a","650":"4978cbe1","774":"cb7b5159","850":"71545ae5","883":"14143fd5","937":"95a17c81"}[chunkId] + ".chunk.js";
};